import { PieChart } from '@mui/x-charts/PieChart';
import { Grid2, Card, CardActions, CardContent, CardHeader, Typography, Box, IconButton, } from '@mui/material';
import { ElectricMeter, GasMeter, Info, MoreVertOutlined } from '@mui/icons-material';
import { useSideScreen } from '../../../Layout/backoffice';
import UsageDetails from '../../../sidescreen/usageDetails';
import Text from '../../../genericComponents/Text';
import Loader from '../../../genericComponents/Loader';
import { gql, useQuery } from '@apollo/client';
const PieChartCard = ({ id, level, start, end,height }) => {

  const TOTALQUERY = `query getTotals($id:UUID!, $level:Level!,$start:DateTime!,$end:DateTime!){
    g:totalData(chartInput:{id: $id,level: $level, meterType: GAS,start:$start ,end:$end}){
      value
    }
    e:totalData(chartInput:{id: $id,level: $level, meterType:ELECTRICITY,start:$start ,end:$end}){
      value
    }
  }`;
  const { data, loading } = useQuery(gql(TOTALQUERY),
    { variables: { id: id, level: level, start: start, end: end } });
    const { openSideScreen } = useSideScreen();    
     
  return (<> <Grid2 container spacing={2}>
  <Grid2 size={{ md: 6, xs: 12 }}>
      <Card>
        <CardHeader sx={{ height:61, borderBottom: "1px solid #ddd" }}
          title={<Grid2 container spacing={1} sx={{ display: "flex", alignItems: "center" }}><ElectricMeter fontSize='large' /><Text variant="h2" text={"i18n_etotal"} /></Grid2>}
          action={<div style={{ display: "flex" }}>
            <IconButton 
            onClick={() => openSideScreen(UsageDetails,{data:{id:id,end:end,start:start,level:level,meterType:"ELECTRICITY"}})} 
            aria-label="settings">
              <Info />
            </IconButton></div>
          }
        />
        <CardContent sx={{ height: (height / 2), display: "flex", justifyContent: "center", alignItems: "center", }}>
          <Typography variant='h1'>{!data || loading ? <Loader /> : (data.e.value).toLocaleString() + ' kWh'}</Typography>
        </CardContent>
      </Card>    
  </Grid2>
  <Grid2 size={{ md: 6, xs: 12 }}>
      <Box>
        <Card>
          <CardHeader sx={{ borderBottom: "1px solid #ddd" }} title={<Grid2 container spacing={1} sx={{ display: "flex", alignItems: "center" }}><GasMeter fontSize='large' /><Text variant="h2" text={"i18n_gtotal"} /></Grid2>}
            action={<div style={{ display: "flex" }}>
            <IconButton onClick={() => openSideScreen(UsageDetails,{data:{id:id,end:end,start:start,level:level,meterType:"GAS"}})} aria-label="settings">
              <Info />
              </IconButton></div>} />
          <CardContent sx={{ height: (height / 2), display: "flex", justifyContent: "center", alignItems: "center", }}>
            <Typography variant='h1'>{!data || loading ? <Loader /> : (data.g.value).toLocaleString() + ' m3'}</Typography>
          </CardContent>
        </Card>
      </Box>
    </Grid2>
    </Grid2>
    </>
        
  );
}
export default PieChartCard